import React, { useMemo, useState } from 'react'
import CommonCard from '../../../global/card'
import CommonSkeletonLoader from '../../../global/loading'
import { useGenericQuery } from '../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import EnhanceLeadSourceList from './enhanceLeadSourceList';
import EnhanceAddLeadSource from './enhanceAddLeadSource';
import CommonDrawer from '../../../global/drawer';
import EnhancedLeadSourceDetails from './enhancedLeadSourceDetails';

const EnhancedLeadSources = () => {
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });
    const [editLeadSource, setEditLeadSource] = useState({
        show: false,
        isEditable: false,
        id: null
    });

    const [viewDetail, setViewDetail] = useState({
        show: false,
        data: null
    });

    const [leadSourcesViewType, setLeadSourcesViewType] = useState(() => {
        return localStorage.getItem("leadSourcesViewType") || "GRID";
    });

    const keyParams = {
        sortBy: sort.sortType,
        sortOrder: sort.sortOrder
    }
    const queryKey = QUERY_KEYS.leadSources.lists(keyParams)

    const { data, isLoading, isFetching, refetch } = useGenericQuery(
        {
            queryKey,
            queryParams: keyParams,
            endpoint: "leadsource",
            onError: () => { },
            onSuccess: () => { }
        }
    )

    const getFinalData = useMemo(() => {
        if (data && Array.isArray(data)) return data
        return []
    }, [data])

    return (
        <CommonCard
            isCreateButton={{
                show: true,
                text: "Add New Job",
                onclick: () => setEditLeadSource({
                    show: true,
                    isEditable: false,
                    id: null
                })
            }}
            isListGridView={{
                show: true,
                viewType: leadSourcesViewType,
                setViewType: setLeadSourcesViewType,
                viewFor: "leadSourcesViewType"
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={leadSourcesViewType === "GRID" ? "card" : "table"}
                        tableLength={5}
                    />
                ),
            }}

            className={(!isLoading && isFetching) && "opacity-50"}
        >
            <EnhanceLeadSourceList
                jobs={getFinalData}
                sort={sort}
                setSort={setSort}
                getLeadSources={refetch}
                isLoading={isLoading}
                keyParams={keyParams}
                setEditLeadSource={setEditLeadSource}

                viewType={leadSourcesViewType}
                setViewDetail={setViewDetail}
            />

            {editLeadSource.show && (
                <EnhanceAddLeadSource
                    showForm={editLeadSource.show}
                    setShowForm={() => setEditLeadSource({ show: false, isEditable: false, id: null })}
                    editLeadSource={editLeadSource}
                    keyParams={keyParams}
                    getLeadSources={refetch}
                />
            )}

            {
                viewDetail.show && (
                    <CommonDrawer
                        open={viewDetail.show}
                        setOpen={() => setViewDetail({ show: false, data: null })}
                        title="Lead Source Details"
                        width={"600px"}
                        children={
                            <EnhancedLeadSourceDetails
                                leadSourceDetail={viewDetail.data}
                                setShowDetail={(show) => setViewDetail(prev => ({ ...prev, show }))}
                            />
                        }
                    />
                )
            }
        </CommonCard>
    )
}

export default EnhancedLeadSources